// Resolve clipboard payload for clippy triggers.
// Supports:
//   data-clipboard-text  — static text on the trigger
//   data-clipboard-selectors — CSS selectors to INPUT/TEXTAREA/SELECT (uses .value)
//     or elements with data-clipboard-text / text content
//   data-clipboard-html  — optional text/html alongside text/plain
//
// Pure DOM (no jQuery) so selector resolution is unit-testable without a browser.

/**
 * @param {Element} trigger
 * @param {{ query?: (selector: string) => Element | null }} [options]
 * @returns {{ 'text/plain': string, 'text/html'?: string }}
 */
export function prepareClipboardData(trigger, options = {}) {
  const query =
    options.query ||
    ((selector) =>
      typeof document !== 'undefined' ? document.querySelector(selector) : null)

  const selectorsAttr =
    trigger.getAttribute?.('data-clipboard-selectors') ||
    trigger.dataset?.clipboardSelectors

  let text
  if (selectorsAttr) {
    text = ''
    for (const raw of selectorsAttr.split(',')) {
      const selector = raw.trim()
      if (!selector) continue
      const el = query(selector)
      if (!el) continue

      const nestedClipboardText =
        el.getAttribute?.('data-clipboard-text') || el.dataset?.clipboardText
      if (nestedClipboardText != null && nestedClipboardText !== '') {
        text += nestedClipboardText
        continue
      }

      const nodeName = (el.nodeName || '').toUpperCase()
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(nodeName)) {
        text += el.value ?? ''
      } else {
        text += el.textContent ?? ''
      }
    }
  } else {
    text =
      trigger.getAttribute?.('data-clipboard-text') ||
      trigger.dataset?.clipboardText ||
      ''
  }

  const html =
    trigger.getAttribute?.('data-clipboard-html') || trigger.dataset?.clipboardHtml

  const data = { 'text/plain': text }
  if (html) data['text/html'] = html
  return data
}
